




















import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { ColorConstruct } from "@/utilityModels/colorConstruct";

import BorderController from "./borderController/borderController.vue";
import FlipController from "./flipController/flipController.vue";

@Component({
    components: {
        BorderController,
        FlipController
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class SettingController extends Vue 
{
    @Prop() borderColor! : ColorConstruct;

    private controllerType = "border";

    private changeType(type : string)
    {
        this.controllerType = type;
    }

    private onDoCommand(command : string, parameter : any)
    {
        this.$emit("doCommand", command, parameter);
    }
}
